import {FC, memo} from 'react';
import {EllipseButton, useModal} from 'ui-kit';
import {useScreenSize} from '@kcast-fe/ui-kit';
import {ROUTES} from 'core';

interface IProps {
  label?: string | number;
}

const DocumentsButtonFC: FC<IProps> = ({label}) => {
  const {isLessThan768} = useScreenSize();
  const {openModal} = useModal();

  return (
    <EllipseButton
      isBordered
      size={'normal'}
      iconSize={'s24'}
      variant={'darkLight'}
      icon={'Attachment'}
      labelPosition={isLessThan768 ? 'left' : 'top-right'}
      onClick={() => openModal(ROUTES.Modal.Documents)}
      label={label}
    />
  );
};

export const DocumentsButton = memo(DocumentsButtonFC);
